<template>
    <div>
        <a href="" @click.prevent="setLocale('en')">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 797.24409 531.49606"
            >
                <g transform="translate(0,-520.86614)">
                    <rect
                        style="fill:#012169;fill-opacity:1;stroke:none"
                        width="797.24408"
                        height="531.49554"
                        x="3.6328123e-07"
                        y="520.86584"
                    />
                    <path
                        style="fill:#ffffff;fill-opacity:1;stroke:none"
                        d="m 6.72e-4,520.86606 0,0.13672 265.685548,177.03125 -59.45898,0 L 6.72e-4,560.62192 l 0,19.80469 176.505858,117.60742 -176.505858,0 0,177.15625 176.505858,0 L 6.72e-4,992.7977 l 0,59.4238 265.685548,-177.03122 44.35742,0 0,10.05078 -250.8125,167.11724 29.728516,0 221.083984,-147.30865 0,147.30865 22.13867,0 13.29102,0 106.29883,0 0,0 35.42969,0 0,-147.30864 221.08007,147.30664 88.95899,0 0,-0.1348 -265.68555,-177.03122 59.45703,0 206.22852,137.41212 0,-19.8047 -176.50586,-117.60742 176.50586,0 0,-177.1582 -176.50586,0 176.50586,-117.60742 0,-59.42383 -265.68555,177.03125 -44.35351,0 0,-10.05469 250.80859,-167.11328 -29.72852,0 -221.08007,147.30664 0,-147.30469 -22.14258,0 0,-0.002 -119.58594,0 -13.29102,0 -22.13867,0 0,147.30859 -221.083984,-147.30859 -88.958984,0 z"
                        id="rect3338"
                        inkscape:connector-curvature="0"
                    />
                    <path
                        style="fill:#c8102e;fill-opacity:1;stroke:none"
                        d="m 358.76239,520.86606 0,0.002 -13.28906,0 0,212.59571 -345.472658,0 0,106.29883 345.472658,0 0,212.5977 106.29883,0 0,-212.5977 345.46875,0 0,-106.29883 -345.46875,0 0,-212.59571 -13.28516,0 0,-0.002 -79.72461,0 z"
                        id="rect3387"
                        inkscape:connector-curvature="0"
                    />
                    <path
                        style="fill:#c8102e;fill-opacity:1;stroke:none"
                        d="m 738.01825,520.86606 -250.8164,167.11914 0,10.04883 44.35351,0 265.68555,-177.03125 0,-0.13672 -59.22266,0 z"
                        id="rect3491"
                        inkscape:connector-curvature="0"
                    />
                    <path
                        inkscape:connector-curvature="0"
                        style="fill:#c8102e;fill-opacity:1;stroke:none"
                        d="m 1.4e-5,521.00258 0,39.61911 206.228026,137.41197 59.45797,0 L 1.4e-5,521.00258 Z"
                        id="rect3497"
                    />
                    <path
                        style="fill:#c8102e;fill-opacity:1;stroke:none"
                        d="M 265.68622,875.19419 6.72e-4,1052.2254 l 0,0.1348 59.222656,0 0,0 250.820312,-167.12109 0,-10.04687 -44.35742,0 z"
                        id="rect3491-9"
                        inkscape:connector-curvature="0"
                    />
                    <path
                        inkscape:connector-curvature="0"
                        style="fill:#c8102e;fill-opacity:1;stroke:none"
                        d="m 797.2441,1052.2249 0,-39.6194 -206.22802,-137.41191 -59.45801,0 265.68603,177.03131 z"
                        id="rect3497-6"
                    />
                </g>
            </svg>
        </a>

        <a href="" @click.prevent="setLocale('de')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 3">
                <desc>Flag of Germany</desc>
                <path d="M0 0h5v3H0z" />
                <path fill="#D00" d="M0 1h5v2H0z" />
                <path fill="#FFCE00" d="M0 2h5v1H0z" /></svg
        ></a>

        <a href="" @click.prevent="setLocale('nl')"
            ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 6">
                <path fill="#21468B" d="M0 0h9v6H0z" />
                <path fill="#FFF" d="M0 0h9v4H0z" />
                <path fill="#AE1C28" d="M0 0h9v2H0z" /></svg
        ></a>

        <a href="" @click.prevent="setLocale('fr')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2">
                <path fill="#ED2939" d="M0 0h3v2H0z" />
                <path fill="#fff" d="M0 0h2v2H0z" />
                <path fill="#002395" d="M0 0h1v2H0z" /></svg
        ></a>
    </div>
</template>

<script>
export default {
    methods: {
        setLocale(locale) {
            console.log(locale);
            this.$i18n.locale = locale;
            bookingLangToInject = locale;
        }
    }
};
</script>

<style scoped>
a {
    margin: 0 0.25rem;
}
svg {
    width: 24px;
    height: 16px;
}
</style>
